import { Component } from '@angular/core';

@Component({
  selector: 'hdw-about-hiv-tool',
  templateUrl: './about-hiv-tool.component.html',
  styleUrls: ['./about-hiv-tool.component.scss']
})
export class AboutHivToolComponent {}
